import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  ordersdata: [],   // array storage
};

const ordersDataSlice = createSlice({
  name: "ordersData",
  initialState,
  reducers: {
    // set full array
    setOrdersData: (state, action) => {
      state.ordersdata = action.payload;
    },

    // add single order
    addOrder: (state, action) => {
      state.ordersdata.push(action.payload);
    },

    // remove order by id
    removeOrder: (state, action) => {
      state.ordersdata = state.ordersdata.filter(
        (item) => item.id !== action.payload
      );
    },

    // clear all
    clearOrders: (state) => {
      state.ordersdata = [];
    },
  },
});

export const {
  setOrdersData,
  addOrder,
  removeOrder,
  clearOrders,
} = ordersDataSlice.actions;

export default ordersDataSlice.reducer;
